import React from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { withRouter } from 'react-router-dom';
import FilterCategory from '../WpCategory';
import WpPostList from '../WpPostList';
import PageWrap from '../../components/page-wrap';
import Helmet from 'react-helmet';
import { isMobile } from 'mobile-device-detect';
import {
  mainMediumRectangle, mainMobileLeaderboard,
  mainTower,
  secondaryMediumRectangle,
  tertiaryMediumRectangle,
} from '../WpPostDetail/WpPostDetailComponent';

// function useQuery() {
//   return new URLSearchParams(useLocation().search);
// }

class Articles extends React.PureComponent {
  render() {
    const query = queryString.parse(this.props.location.search);
    let category = query.category || 'all';
    let options = { category };
    // FIXME The categories should be part of the path, not as a query - /articles/categories/:slug
    if (query.search) {
      category = 'search';
      options = { category, search: query.search };
    }

    return (
      <PageWrap>
        <Helmet>
          <title>Articles | Cigars Near Me</title>
        </Helmet>

        <div>
          <FilterCategory selected={category} />
          {isMobile && (
            <div style={{ width: '100%', textAlign: 'center', marginTop: 16 }}>
              {mainMobileLeaderboard()}
            </div>
          )}
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div style={{ flex: 1 }}>
              <WpPostList
                name={category}
                options={options}
              />
            </div>
            {!isMobile && (
              <div style={{ width: 310, marginLeft: 20, marginTop: 30 }}>
                {mainTower()}
                {mainMediumRectangle()}
                {secondaryMediumRectangle()}
                {tertiaryMediumRectangle()}
              </div>
            )}
          </div>
        </div>
      </PageWrap>
    );
  }
}

Articles.propTypes = {
  location: PropTypes.object.isRequired,
};

export default withRouter(Articles);
